import Loader from 'components/Icons/LoadingSpinner'
import { useIsAdmin, useIsLiquidityProvider } from 'config/walletAccess'
import { useWalletConnect } from 'connection/wallet-connect/hooks/use-wallet-connect'
import { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'
import styled from 'styled-components/macro'
import { Z_INDEX } from 'theme/zIndex'
import { useAccount } from 'wagmi'

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
  position: absolute;
  inset: 0;
  z-index: ${Z_INDEX.modal};
  background-color: ${({ theme }) => theme.backgroundScrim};
`

export default function PrivateRouteGuard({ children }: PropsWithChildren) {
  const isAdmin = useIsAdmin()
  const isProvider = useIsLiquidityProvider()

  const { isConnected, address, isReconnecting: isWagmiReconnecting, isConnecting: isWagmiConnecting } = useAccount()
  const { isReconnecting: isContextReconnecting } = useWalletConnect()

  const isLoading = isWagmiReconnecting || isContextReconnecting || isWagmiConnecting

  if (isLoading) {
    return (
      <LoaderWrapper>
        <Loader size="40px" />
      </LoaderWrapper>
    )
  }

  if (!isConnected || !address) {
    return <Navigate to="/" replace />
  }

  if (!isAdmin && !isProvider) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
